module.exports = __webpack_public_path__ + "static/skills2-a5d94875420c391302ad5a906b6df801.svg";